import { useSearchParams } from 'react-router-dom';

export const usePreview = () => {
  const [searchParams] = useSearchParams();
  const previewToken = searchParams.get('previewToken') ?? undefined;

  return {
    previewToken,
  };
};
